import React from "react";
import insuranceAprilLogo  from "../assets/images/insu-april.svg";
import insuranceAllianzLogo  from "../assets/images/insu-allianz.svg";
import insuranceMSHLogo  from "../assets/images/insu-msh.svg";
import insuranceHennerLogo  from "../assets/images/insu-henner.svg";
import Tooltip from "../components/GlobalComponents/Tooltip/Tooltip";
import {Trans} from 'react-i18next';

export function renderTypeOfCoverageList(coverage_types_included, insurance_company, plan_id) {

    switch (coverage_types_included) {
        case 'H':
            return (
                <ul>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_hospitalization"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_healthcare"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_optical"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_maternity"></Trans></li>
                </ul>
            );
        case 'H+RC':
            return (
                <ul>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_hospitalization"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_healthcare"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_optical"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_maternity"></Trans></li>
                </ul>
            );
        case 'H+M':
            return (
                <ul>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_hospitalization"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_healthcare"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_optical"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span>
                        Maternité
                        {(insurance_company === 'Allianz')
                            ?
                                <Tooltip
                                    tooltipId={`coverage_mat_${plan_id}`}
                                    tooltipType="light"
                                    tooltipEffect="solid"
                                    tooltipIconSize={14}
                                    tooltipIconTopPosition={2}
                                    tooltipIconOffset={5}
                                    tooltipContent="
                                       Chez Allianz, l’option maternité est incluse de base avec
                                       l’hospitalisation. Toutes les offres comprennent
                                       l’option maternité, sans surcoût."
                                />
                            : null }
                    </li>
                </ul>
            );
        case 'H+RC+OD':
            return (
                <ul>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_hospitalization"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_healthcare"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_optical"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_maternity"></Trans></li>
                </ul>
            );
        case 'H+RC+M':
            return (
                <ul>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_hospitalization"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_healthcare"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_optical"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span>
                        Maternité
                        {(insurance_company === 'Allianz')
                            ?
                            <Tooltip
                                tooltipId={`coverage_mat_${plan_id}`}
                                tooltipType="light"
                                tooltipEffect="solid"
                                tooltipIconSize={14}
                                tooltipIconTopPosition={2}
                                tooltipIconOffset={5}
                                tooltipContent="
                                       Chez Allianz, l’option maternité est incluse de base avec
                                       l’hospitalisation. Toutes les offres comprennent
                                       l’option maternité, sans surcoût."
                            />
                            : null }
                    </li>
                </ul>
            );
        case 'H+RC+OD+M':
            return (
                <ul>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_hospitalization"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_healthcare"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_optical"></Trans></li>
                    <li className="included-coverage"><span className="icon-check-mark"></span>
                        Maternité
                        {(insurance_company === 'Allianz')
                            ?
                            <Tooltip
                                tooltipId={`coverage_mat_${plan_id}`}
                                tooltipType="light"
                                tooltipEffect="solid"
                                tooltipIconSize={14}
                                tooltipIconTopPosition={2}
                                tooltipIconOffset={5}
                                tooltipContent="
                                       Chez Allianz, l’option maternité est incluse de base avec
                                       l’hospitalisation. Toutes les offres comprennent
                                       l’option maternité, sans surcoût."
                            />
                            : null }
                    </li>
                </ul>
            );
        default:
            return (
                <ul>
                    <li className="included-coverage"><span className="icon-check-mark"></span><Trans i18nKey="coveregePage_filter_needed_hospitalization"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_healthcare"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_optical"></Trans></li>
                    <li className="not-included-coverage"><span className="icon-close"></span><Trans i18nKey="coveregePage_filter_needed_maternity"></Trans></li>
                </ul>
            );
    }

}


export function renderGuaranteeLevelNameTag(guarantee_level_EA_displayed) {

    switch (guarantee_level_EA_displayed) {
        case 'Basic':
            return (
                <div className="planGuaranteeLevelName" style={{backgroundColor: "#D6D6D6"}}><span className="icon-star-one"></span> { guarantee_level_EA_displayed }</div>
            );
        case 'Comfort':
            return (
                <div className="planGuaranteeLevelName" style={{backgroundColor: "#D7CBA4"}}><span className="icon-star-two"></span> { guarantee_level_EA_displayed }</div>
            );
        case 'VIP':
            return (
                <div className="planGuaranteeLevelName" style={{backgroundColor: "#FFCB12"}}><span className="icon-star-three"></span> { guarantee_level_EA_displayed }</div>
            );
        default:
            return null;
    }

}


export function renderInsuranceCompanyLogo(insurance_company) {

    switch (insurance_company) {
        case 'April':
            return insuranceAprilLogo;

        case 'Allianz':
            return insuranceAllianzLogo;

        case 'MSH':
            return insuranceMSHLogo;

        case 'Henner':
            return insuranceHennerLogo;

        default:
            return insuranceAprilLogo;
    }

}


export function generateFormattedPrice(price_value, currency) {
    let formatter;

    if (currency === 'USD') {
        formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
        });
    } else {
        formatter = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: currency,
        });
    }


    return formatter.format(price_value);

}


export function embedHubSpotInitScripts() {

    // TODO: ця вся реалізація через iframe не камельфо, можливо потім через API зробити

    setTimeout(function () {

        // видаляємо старий script хабспота, щоб при повторному відкриванні, можна було б його знову ініціалізувати
        let hubspot_meetings_iframe_dom = document.getElementById('hubspot_meetings_iframe');

        if (hubspot_meetings_iframe_dom ) {

            hubspot_meetings_iframe_dom.parentNode.removeChild(hubspot_meetings_iframe_dom);

        }

        // вставляємо script хабспотам щоб ініціалізувати iframe
        const script = document.createElement('script');
        script.id = 'hubspot_meetings_iframe';
        script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
        document.body.appendChild(script);

    }, 100);

}


export function textInputValidation(string_from_input) {

    if ( string_from_input && string_from_input.trim().length > 0 ) {

        return true;

    } else {

        return false;

    }

}


export function emailInputValidation(string_from_input) {

    let emailReg = /^(([^<>() [\]\\.,;:\s@"]+(\.[^<>() [\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if ( emailReg.test(String(string_from_input).toLowerCase()) ) {

        return true;

    } else {

        return false;

    }

}


export function getAdultsAmount(insurees_data, data_type) {

    if ( data_type === 'solid_array' ) {

        let adults_count = 0;

        if ( insurees_data ) {

            insurees_data.forEach(item_insuree => {

                if (item_insuree.age > 26) {

                    adults_count++;

                }

            });

        }

        return adults_count;

    } else {

        let adults_count = 0;
        let dependents_array = insurees_data.dependents_array;
        let insuree_object_age = insurees_data.insuree_object.age;

        if ( insuree_object_age > 26 ) {

            adults_count++;

        }

        if ( dependents_array ) {

            dependents_array.forEach(item_dependent => {

                if( item_dependent.age > 26 ) {

                    adults_count++;

                }

            });

        }

        return adults_count;

    }

}






function lookup_in_April_deductible_table(coverage_types_included, destination_zone, deductible_value){
    //if deductible is 0 then there's no need to transform anything, it'll stay 0, exit the function
    if (deductible_value === 0) {
        return 0;
    }
    let deductibleSteps = {
        "500": 0,
        "1000": 1,
        "2500": 2,
        "5000": 3
    };
    let deductibleCoefficientsWhenValue500 = {};

    switch(coverage_types_included) {
        case 'H': {
            //we're in the first square
            deductibleCoefficientsWhenValue500 = {
                'Zone 5': '75',
                'Zone 4B': '80',
                'Zone 4': '80',
                'Zone 3': '80',
                'Zone 2': '83',
                'Zone 1': '85',
                'Zone 0': '95',
            };

            break;
        }

        case 'H+RC':
        case 'H+RC+M': {
            //second square
            deductibleCoefficientsWhenValue500 = {
                'Zone 5': '80',
                'Zone 4B': '85',
                'Zone 4': '85',
                'Zone 3': '85',
                'Zone 2': '88',
                'Zone 1': '90',
                'Zone 0': '97',
            };
            break;
        }

        case 'H+RC+OD':
        case 'H+RC+OD+M': {
            //third square
            deductibleCoefficientsWhenValue500 = {
                'Zone 5': '85',
                'Zone 4B': '90',
                'Zone 4': '90',
                'Zone 3': '90',
                'Zone 2': '93',
                'Zone 1': '95',
                'Zone 0': '98',
            };
            break;
        }

        default:
            return null
    }

    /**
     * the formula means: take the highest coefficient for 500 and detract 5% each time you move right in the table
     * this way for e.g. deductible 2500 and zone 3 HOS coverage type, starting coefficient will be 80,
     * then we detract 5% 2 times - go two steps to the right in the table to reach coefficient for 2500 which is two steps from 500
     */
    let finalDeductibleCoefficient =
        deductibleCoefficientsWhenValue500[destination_zone] - 5 * deductibleSteps[deductible_value];
    console.log("April deductible returning coefficient: " + finalDeductibleCoefficient);
    return finalDeductibleCoefficient; 
}


function calculateFinalPriceApril(payment_frequency, insurees_number, spreadsheet_rows, coverage_types_included, deductible_value, coinsurance_value, destination_zone, currency) {

    let coefficient; //a coefficient that takes the value of coinsurance or deductible to calculate the final price
    let price_repatriation; //a price of repatriation, here only basic
    let sum_prices = 0; // a variable for summed basic prices for premium

    // if there is deductible (only when CFE is not there), then the price will be changed based on deductible value, otherwise the coinsurance is taken
    if( deductible_value > 0 )
        coefficient = lookup_in_April_deductible_table(coverage_types_included, destination_zone, deductible_value);
    else
        coefficient = coinsurance_value;

    //we are paying for maximum 4 people (the 3rd and next kid is for free)
    let paid_insurees_number = Math.min(insurees_number, 4);

    // summing up the price all paid insurees
    //TODO: here we need to have spreadsheet_rows[i]["Tarif ANNUEL FDS TTC"] sorted from top (the oldest person)
    // to bottom (the youngest kid) to make sure we don't add up cheaper prices of children in the sum while leaving out
    // adults in the end.
    for (var i = 0; i < paid_insurees_number; i++){

        if ( spreadsheet_rows[i] ) {

            sum_prices += spreadsheet_rows[i]["Tarif ANNUEL FDS TTC"];

        }

    }

    //not longer relevant: sum_prices = spreadsheet_rows.sum("Tarif ANNUEL FDS TTC", paid_insurees_number);
    price_repatriation = paid_insurees_number*117;

    // currency coefficient will be used for different currencies. by default April's price is coming from
    // pricing spreadsheets in EUR, we multiply it by coefficient 1 (fixed, provided by EA) to display price in USD
    // when destination country is USA and we want to show all plans in USD
    let currency_coefficient = 0;
    if (currency === 'USD') {
        //april's coefficient is quite strange and makes April really lose money on this, but ok, it's same price in USD as in eur for now
        currency_coefficient = 1;
    } else {
        //with EURO - don't apply coefficient since the price is already in euro from the spreadsheet
        currency_coefficient = 1;
    }

    let total_sum = currency_coefficient * coefficient*(sum_prices)/100+price_repatriation;


    return (total_sum / payment_frequency).toFixed(2);
}

function calculateFinalPriceAllianz(payment_frequency, insurees_number, spreadsheet_rows, coverage_types_included, coinsurance_value, currency) {

    var price_outpatient = 0; // declaring variable, price will be based on selected by user outpatient (coinsurance) option
    var sum_prices = 0; // a variable for summed basic prices for premium
    var dental_price = 0;
    var basic_price;
    var total_sum;
    var outpatient_index; // based on the coinsurance value; 100% -> 1, 90% ->2, 80% ->3; in order to take the right price from the row

    if(coinsurance_value === 100)
        outpatient_index = 1;
    else if (coinsurance_value === 90)
        outpatient_index = 2;
    else
        outpatient_index = 3;


    for (var i = 0; i < insurees_number; i++){
        basic_price = spreadsheet_rows[i][0];

        //we only add up outpatient price IF the plan doesn't include RC
        //only H+M plans don't include RC in Allianz - All1, All3, that's why we only set price_outpatient
        // for all the other plans but not these two with this condition
        if (coverage_types_included !== 'H+M'){
            price_outpatient = spreadsheet_rows[i][outpatient_index];
        }
        if (coverage_types_included === "H+RC+OD" || coverage_types_included === "H+RC+OD+M" ){
            dental_price = spreadsheet_rows[i][4];
        }
        sum_prices += basic_price + price_outpatient + dental_price
    }

    // currency coefficient will be used for different currencies. by default Allianz's price is coming from
    // pricing spreadsheets in EUR, we multiply it by coefficient (fixed, provided by EA) to display price in USD
    // when destination country is USA and we want to show all plans in USD
    let currency_coefficient = 0;
    if (currency === 'USD') {
        currency_coefficient = 1.2;
    } else {
        //with EURO - don't apply coefficient since the price is already in euro from the spreadsheet
        currency_coefficient = 1;
    }
    console.log("Allianz price before currency coefficient: " + sum_prices + " EUR");
    sum_prices *= currency_coefficient;
    console.log("Allianz price after currency coefficient: " + sum_prices + " USD");

    switch (payment_frequency){
        case 12:
            total_sum = 1.05*sum_prices;
            break;
        case 4:
            total_sum = 1.04*sum_prices;
            break;
        case 2:
            total_sum = 1.03 * sum_prices;
            break;
        default: //yearly price
            total_sum = sum_prices;
    }

    return (total_sum / payment_frequency).toFixed(2);
}

function calculateFinalPriceMSH(payment_frequency, insurees_number, spreadsheet_rows, deductible_value, currency) {
    var price_liability; //a price of liability, always included in the price
    var sum_prices = 0; // a variable for summed basic prices for premium

    //since alasql doesn't work with "0" value in excel sheets we needed to rename it to "null", therefore in resuling spreadsheet_rows
    // it will also return as null, so we're replacing the value here to be able to correctly query for it
    if (deductible_value === 0) {
        deductible_value = "null";
    }


    // we are paying for maximum 4 people (the 3rd and next kid is for free)
    var paid_insurees_number = Math.min(insurees_number, 4);
    for (var i = 0; i < paid_insurees_number; i++){
        sum_prices += spreadsheet_rows[i][deductible_value];
    }

    if (insurees_number > 1)
        price_liability = 158.04;
    else
        price_liability = 117.2;

    var total_sum = (sum_prices+price_liability);

    return (total_sum/payment_frequency).toFixed(2);
}

function calculateFinalPriceHenner(payment_frequency, insurees_number, spreadsheet_rows, company_guarantee_level, currency) {
    let formule = company_guarantee_level;
    //since formule is saved in boilerplate plans with dash, replace it with space to access the value in an array
    //returning from the backend

    formule = formule.replace("-", ' ');


    var sum_prices = 0; // a variable for summed basic prices for premium

    // different way of counting for 1-2, >3 people
    if(insurees_number <3){
        for(var i=0; i<insurees_number; i++)
            sum_prices += spreadsheet_rows[i][formule];
    }else{
        //in case if there are >3 people back-end will return only one spreadsheet row that will be the price for all the people together
        sum_prices = spreadsheet_rows[0][formule];
    }

    //the prices are quarterly, therefore we multiply them by 4 for an yearly price
    var total_sum = 4*sum_prices;

    return total_sum/payment_frequency;
}

export function calculateFinalPrice(insurance_company, payment_frequency, insurees_number, spreadsheet_rows, coverage_types_included, deductible_value, coinsurance_value, destination_zone, company_guarantee_level, currency) {

    switch (insurance_company) {
        case 'April':
            // return 1000;
            return calculateFinalPriceApril(payment_frequency, insurees_number, spreadsheet_rows, coverage_types_included, deductible_value, coinsurance_value, destination_zone, currency);

        case 'Allianz':
            return calculateFinalPriceAllianz(payment_frequency, insurees_number, spreadsheet_rows, coverage_types_included,coinsurance_value, currency);

        case 'MSH':
            return calculateFinalPriceMSH(payment_frequency, insurees_number, spreadsheet_rows, deductible_value, currency);

        case 'Henner':
            return calculateFinalPriceHenner(payment_frequency, insurees_number, spreadsheet_rows, company_guarantee_level, currency);

        default:
            return "error";
    }

}



